import Switch from '@mui/material/Switch'
import { Box, Checkbox, ListItemText, MenuItem, Select, Typography } from '@mui/material';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { useEffect, useState } from 'react'
import { showDangerToast, showToast } from '../../constants/toaster'
import { useDispatch, useSelector } from 'react-redux'
import { updateLoading } from '../../../redux/features/common/commonSlice'
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';

const label = { inputProps: { 'aria-label': 'Size switch demo' } }

export const AddViewerSubscription = (props) => {
    const userData = useSelector(state => state?.userData)
    const [selectedCountryValues, setSelectedCountryValues] = useState([]);
    const [countryDataList, setCountryDataList] = useState([])
    const [allNetworkProviders, setAllNetworkProviders] = useState([]);
    const [selectedNetworkProviderValues, setSelectedNetworkProviderValues] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (props?.show) {
            getCountryKeyValuePair()
            if (props?.viewerSubscriptionFormData?.selectedCountries) {
                setSelectedCountryValues(props?.viewerSubscriptionFormData?.selectedCountries)
            }
            if (props?.viewerSubscriptionFormData?.selectedNetworkProviders) {
                setSelectedNetworkProviderValues(props?.viewerSubscriptionFormData?.selectedNetworkProviders)
            }
        }
    }, [props?.show])

    const handleSubmit = async () => {
        let validateSuccess = false;
        
        // Basic validation
        if (
            props?.viewerSubscriptionFormData?.name &&
            props?.viewerSubscriptionFormData?.amount &&
            props?.viewerSubscriptionFormData?.duration &&
            props?.viewerSubscriptionFormData?.category &&
            selectedCountryValues.length > 0 &&
            selectedNetworkProviderValues.length > 0
        ) {
            validateSuccess = true;
        } else {
            showDangerToast("Please fill all required fields and select at least one country and network provider.");
            return;
        }

        if (validateSuccess) {
            try {
                dispatch(updateLoading(true));
                
                // Prepare network providers array
                const networkProviders = [];
                selectedCountryValues.forEach(countryId => {
                    selectedNetworkProviderValues.forEach(networkProviderId => {
                        networkProviders.push({
                            countryId: countryId,
                            networkProviderId: networkProviderId
                        });
                    });
                });

                const postJson = {
                    id: props?.viewerSubscriptionFormData?.id || "",
                    name: props?.viewerSubscriptionFormData?.name,
                    amount: parseFloat(props?.viewerSubscriptionFormData?.amount),
                    duration: parseInt(props?.viewerSubscriptionFormData?.duration),
                    category: props?.viewerSubscriptionFormData?.category,
                    benefit: props?.viewerSubscriptionFormData?.benefit || "",
                    networkProviders: networkProviders
                };

                console.log('Submitting viewer subscription:', postJson);

                // Use same endpoint for both add and edit
                // For edit: id will be populated from the list response
                // For add: id will be empty string
                const path = urls.addViewerSubscription;
                const res = await ApiCaller.post(postJson, path, userData?.access_token);
                const response = await res.response.json();

                if (response.status === 200 || response.status === '200') {
                    dispatch(updateLoading(false));
                    showToast(response?.message || 'Viewer subscription saved successfully');
                    props.onHide();
                    props.onSubmit(); // Refresh the list
                } else {
                    dispatch(updateLoading(false));
                    showDangerToast(response.message || 'Failed to save viewer subscription');
                }
            } catch (error) {
                dispatch(updateLoading(false));
                console.error('Error saving viewer subscription:', error);
                showDangerToast('Failed to save viewer subscription');
            }
        }
    };

    const handleCountryChange = async (event, type) => {
        if (type === 0) {
            setSelectedCountryValues(event.target.value);
            props?.setViewerSubscriptionFormData({
                ...props?.viewerSubscriptionFormData,
                selectedCountries: event?.target?.value
            })
        } else if (type === 1) {
            setSelectedNetworkProviderValues(event.target.value);
            props?.setViewerSubscriptionFormData({
                ...props?.viewerSubscriptionFormData,
                selectedNetworkProviders: event?.target?.value
            })
        }
    }

    const getCountryKeyValuePair = async () => {
        try {
            dispatch(updateLoading(true))
            let path = urls.countryCodeList
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setCountryDataList(response?.data)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const handleNetworkProvidersOpen = async () => {
        try {
            if (!selectedCountryValues?.length) return;

            dispatch(updateLoading(true));
            // Fetch all network providers in parallel
            const responses = await Promise.all(
                selectedCountryValues.map((data) => getCountryNetworkProviderList(data))
            );

            // Flatten the array if each response contains an array
            const mergedProviders = responses.flat().filter(Boolean);

            // Update state with the new providers
            setAllNetworkProviders(mergedProviders);
            dispatch(updateLoading(false));
            console.log('Network providers:', mergedProviders);
        } catch (error) {
            dispatch(updateLoading(false));
            console.error("Error fetching network providers:", error);
        }
    };

    const getCountryNetworkProviderList = async (id) => {
        try {
            let path = urls.networkProviderKeyValueByCountry + "?countryId=" + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                return response?.data;
            } else {
                showDangerToast(response.message)
                return [];
            }
        } catch (error) {
            console.error(error)
            showDangerToast(error.message)
            return [];
        }
    }

    return <>
        <Modal
            {...props}
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className="bg-light">
                <Modal.Title id='contained-modal-title-vcenter' className="text-primary">
                    {props?.viewerSubscriptionFormData?.id ? 'Edit Viewer Subscription Plan' : 'New Viewer Subscription Plan'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">
                    {/* Basic Information */}
                    <div className="col-12">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Basic Information</h6>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>Plan Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                maxLength={50}
                                                value={props.viewerSubscriptionFormData.name}
                                                onChange={(e) => props.setViewerSubscriptionFormData({
                                                    ...props?.viewerSubscriptionFormData,
                                                    name: e.target.value
                                                })}
                                                placeholder="Enter plan name"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-3">
                                        <Form.Group>
                                            <Form.Label>Amount (GH₵) <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                value={props.viewerSubscriptionFormData.amount}
                                                onChange={(e) => props.setViewerSubscriptionFormData({
                                                    ...props?.viewerSubscriptionFormData,
                                                    amount: e.target.value
                                                })}
                                                placeholder="Enter amount"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-3">
                                        <Form.Group>
                                            <Form.Label>Duration (seconds) <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="0"
                                                value={props.viewerSubscriptionFormData.duration}
                                                onChange={(e) => props.setViewerSubscriptionFormData({
                                                    ...props?.viewerSubscriptionFormData,
                                                    duration: e.target.value
                                                })}
                                                placeholder="Enter duration"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Category and Benefits */}
                    <div className="col-12">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Plan Details</h6>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>Category <span className="text-danger">*</span></Form.Label>
                                            <Select
                                                value={props.viewerSubscriptionFormData.category}
                                                onChange={(e) => props.setViewerSubscriptionFormData({
                                                    ...props?.viewerSubscriptionFormData,
                                                    category: e.target.value
                                                })}
                                                className="w-100"
                                            >
                                                <MenuItem value="DAILY">Daily</MenuItem>
                                                <MenuItem value="WEEKLY">Weekly</MenuItem>
                                                <MenuItem value="MONTHLY">Monthly</MenuItem>
                                            </Select>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>Benefits</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                maxLength={200}
                                                value={props.viewerSubscriptionFormData.benefit}
                                                onChange={(e) => props.setViewerSubscriptionFormData({
                                                    ...props?.viewerSubscriptionFormData,
                                                    benefit: e.target.value
                                                })}
                                                placeholder="Enter plan benefits"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Location Settings */}
                    <div className="col-12">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Location Settings</h6>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>Countries <span className="text-danger">*</span></Form.Label>
                                            <Select
                                                multiple
                                                value={selectedCountryValues}
                                                onChange={(e) => handleCountryChange(e, 0)}
                                                renderValue={(selected) => `${selected.length} Selected`}
                                                className="w-100"
                                            >
                                                {countryDataList.map((option) => (
                                                    <MenuItem key={option?.name} value={option?.id}>
                                                        <Checkbox checked={selectedCountryValues.indexOf(option?.id) > -1} />
                                                        <ListItemText primary={option?.name} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>Network Providers <span className="text-danger">*</span></Form.Label>
                                            <Select
                                                multiple
                                                value={selectedNetworkProviderValues}
                                                onChange={(e) => handleCountryChange(e, 1)}
                                                onOpen={handleNetworkProvidersOpen}
                                                renderValue={(selected) => `${selected.length} Selected`}
                                                className="w-100"
                                            >
                                                {allNetworkProviders.map((option) => (
                                                    <MenuItem key={option?.value} value={option?.key}>
                                                        <Checkbox checked={selectedNetworkProviderValues.indexOf(option?.key) > -1} />
                                                        <ListItemText primary={option?.value} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={props.onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    {props?.viewerSubscriptionFormData?.id ? 'Update Plan' : 'Create Plan'}
                </Button>
            </Modal.Footer>
        </Modal>
    </>
}